<template>
  <div v-show="visible">
    <div class="popup_wrap editAttribute">
      <div class="popup_title" :style="setBackgroundColor(getSelectedNode?.node?.category)">
        <p><span id="node_title">{{ getSelectedNode?.node?.text }}</span></p>
        <a>
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div class="node_order_wrap">
          <div class="node_order_box_left">
            <h4 class="node_order_tit">강제순서</h4>
            <p style="color: red; font-size: 12px;">
              ※사용자가 노드의 순서를 강제로 지정할 수 있습니다. 사용 설정 시 나머지 노드는 사용자가 강제로 순서를 지정한 노드의 순서를 제외하고
              자동으로 배정됩니다.
            </p>
            <div class="node_name_box">
              <div class="box_stitle2 node_title W100">
                <input style="width: 100px;" type="text" data-key="input" class="W100 validate[required]" v-model="input.nodeForceOrder"
                       :readonly="!input.forceOrderUseYn"
                       @input="inputListener($event,'nodeForceOrder')" @keydown="keydownListener($event,'nodeForceOrder')">
                <label for="use">
                    <input type="radio" name="forceOrderUseYn" id="use" v-bind:value="true" v-model="input.forceOrderUseYn"/>
                    <span>사용</span>
                </label>
                  <label for="notuse">
                    <input type="radio" name="forceOrderUseYn" id="notuse" v-bind:value="false" v-model="input.forceOrderUseYn"/>
                    <span>미사용</span>
                </label><br/>
              </div>
            </div>
            <h4 class="node_order_tit">
              속성
            </h4>
            <table width="100%" border="0" cellspacing="0" cellpadding="0" class="board_node">
              <colgroup>
                <col width="30%">
                <col width="*">
              </colgroup>
              <tbody>
              <tr>
                <th>
                  속성명
                </th>
                <td>
                    <input type="text" data-key="input" v-model="input.propertyName"
                           @input="inputListener($event,'propertyName')" @keydown="keydownListener($event,'propertyName')">
                </td>
              </tr>
              <tr>
                <th style="vertical-align: middle">속성타입</th>
                <td>
                    <label v-for="(type, index) in Object.values(PROPERTY_TYPE)" :key="index" :for="index">
                        <input type="radio" name="propertyType" :id="index" :value="type.value" v-model="input.propertyType"/>
                        <span>{{type.label}}</span>
                    </label>
                </td>
              </tr>
              <tr v-show="!isDistrictValid.includes(input.propertyType)">
                <th>속성단위</th>
                <td>
                    <input type="text" data-key="input" v-model="input.propertyUnit"
                           @input="inputListener($event,'propertyUnit')" @keydown="keydownListener($event,'propertyUnit')">
                </td>
              </tr>
              <tr v-show="!isDistrictValid.includes(input.propertyType)">
                <th>속성기본값</th>
                <td>
                    <input type="text" data-key="input" v-model="input.propertyValue"
                           @input="inputListener($event,'propertyValue')" @keydown="keydownListener($event,'propertyValue')">
                </td>
              </tr>
              <tr>
                <th style="vertical-align: middle">어휘번호</th>
                <td>
                  <VocabularyAutocomplete
                    @select="handleVocabularySelect"
                    :selectedVocabularyId="input.propertyVocabularyId"
                    ref="vocabularyAutocomplete"
                  />
                </td>
              </tr>
              <tr>
                <th style="vertical-align: middle">class</th>
                <td>
                  <select data-key="input" v-model="input.propertyClassId" @change="inputListener($event,'propertyClassId')">
                    <option v-for="(propertyClass, index) in getPropertyClassList" 
                            :key="index" 
                            :value="propertyClass?.id">{{propertyClass?.name}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th style="vertical-align: middle">속성설명</th>
                <td>
                    <textarea type="text" data-key="input" v-model="input.propertyDefine" rows="8" style="resize: none;"
                           @input="inputListener($event,'propertyDefine')" @keydown="keydownListener($event,'propertyDefine')"/>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="text_right mt10">
              <a class="btn_add" @click="addDictionaryProperty">속성추가</a>
            </div>
          </div>
          <div class="node_order_box_right">
            <h4 class="node_order_tit">공정도적용속성</h4>
            <div
              v-for="(prop, index) in sortedProcessAttributes.filter(item => item.active)" :key="prop.uuid" class="node_result_box"
              :draggable="true" @dragstart="attrDragStart($event,index)" @dragover.prevent @drop="attrDragDrop($event,index)">
              <h4 class="site_detail_tit">
                {{prop.propertyName}}
                <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''" v-b-toggle="`edit-attr-process-collapse-${index}`"
                     class="tooltip_box" title="속성설명을 보려면 클릭해주세요.">
                  <span class="tooltip_ico"></span>
                </div>
<!--                <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''" class="tooltip_box">
                  <span class="tooltip_ico"></span>
                  <div class="tooltip_txt">
                    <p style="white-space: pre-line; text-align: left;">{{prop.propertyDefine}}</p>
                  </div>
                </div>-->
                <div class="node_result_box_btn">
                  <a class="btn_node_delete"
                     @click="deleteAttribute('processAttribute', prop.uuid)">&nbsp</a>
                  <a class="btn_node_change">&nbsp;</a>
                </div>
              </h4>
              <div class="site_detail_con">
                <h4 class="site_detail_con">단위 : {{prop.propertyUnit != null && prop.propertyUnit != ""? prop.propertyUnit : "없음"}}
                  | 타입 : {{prop.propertyType != null? Object.values(PROPERTY_TYPE).find(item => item.value==prop.propertyType)?.label : "-"}}
                </h4>
                <h4 v-if="!strIsNull(prop.propertyVocabulary?.code)">
                  어휘번호 :
                  {{createViewVocabularyString(prop.propertyVocabulary)}}
                </h4>
                <h4 v-if="!strIsNull(prop.propertyClass?.name)">class :
                  {{prop.propertyClass?.name}}
                </h4>
                <input v-if="!isDistrictValid.includes(prop.propertyType)" style="margin-top: 5px" type="text" class="W100"
                       data-key="processAttribute" :data-attributeId="prop.uuid"
                       @input="inputListener($event,prop.uuid)" @keydown="keydownListener($event,prop.uuid)" v-model="prop.propertyValue">
              </div>
              <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''">
                <b-collapse :id="`edit-attr-process-collapse-${index}`" class="mt-2" style="cursor:default">
                  <b-card @click.stop>
                    <p style="white-space: pre-line; text-align: left;font-size: 13px; font-weight: bold">{{ prop.propertyDefine }}</p>
                  </b-card>
                </b-collapse>
              </div>
            </div>
            <div v-if="sortedProcessAttributes.filter(item => item.active).length == 0">
              <div class="nodata_txt"><p>적용된 공정도속성이 존재하지 않습니다.</p></div>
            </div>
          </div>
          <div class="node_order_box_middle">
            <h4 class="node_order_tit">속성POOL</h4>
            <div class="search_form_wrap">
              <ul class="search_form_list">
                <li style="width: 87.5%;">
                  <div class="inpt_sch">
                    <input type="text" class="form_control" data-key="searchQuery" v-model="searchQuery"
                           style="background-color: white" placeholder="속성명 검색을 할수있어요."
                           @input="inputListener($event,'searchQuery')"
                           @keydown="keydownListener($event,'searchQuery')"
                    >
                    <button type="button"></button>
                  </div>
                </li>
                <li style="width: 12.5%;">
                  <div class="inpt_sch">
                    <button class="eraser" type="button" @click="searchQuery = null"></button>
                  </div>
                </li>
              </ul>
            </div>
              <p style="font-size: 14px; text-align: right">
                검색조건 결과 : {{ dictionaryAttribute.filter(item => item.searchFlag && item.active).length }}개 /
                총 : {{ dictionaryAttribute.filter(item => item.active).length }}개
              </p>
            <div
              v-for="(prop, index) in dictionaryAttribute.filter(item => item.active && item.searchFlag)" :key="prop.uuid"
              :style="setExistColor(prop)" class="node_result_box">
              <h4 class="site_detail_tit">
                {{prop.propertyName}}
                <a class="btn_node_edit" title="수정"
                    @click="callEditAttributePollPop(prop)"
                  ></a>
<!--                <input type="text" class="W100" data-key="dictionaryAttribute" data-prop="propertyName" :data-attributeId="prop.uuid"
                 @input="inputListener($event,prop.uuid)" @keydown="keydownListener($event,prop.uuid)" v-model="prop.propertyName">-->
                <div class="node_result_box_btn">
                  <a class="btn_node_delete" title="삭제"
                     @click="deleteAttribute('dictionaryAttribute', prop.uuid)">&nbsp</a>
                  <a class="btn_node_plus" title="공정도적용속성으로 추가"
                    @click="addProcessAttribute(prop.dictionaryPropertyId,prop.uuid)"
                  ></a>
                </div>
              </h4>
              <div class="site_detail_con">
                <h4 class="site_detail_con">단위 :  {{prop.propertyUnit != null && prop.propertyUnit != ""? prop.propertyUnit : "없음"}}
                  | 타입 : {{prop.propertyType != null? Object.values(PROPERTY_TYPE).find(item => item.value==prop.propertyType)?.label : "-"}}
                </h4>
                <h4 v-if="!isDistrictValid.includes(prop.propertyType)">속성기본값 :
                  {{prop.propertyValue != null && prop.propertyValue != "" ? prop.propertyValue : ""}}
<!--                  <input type="text" class="W100"
                         data-key="dictionaryAttribute" :data-attributeId="prop.uuid" data-prop="propertyValue"
                         @input="inputListener($event,prop.uuid)" @keydown="keydownListener($event,prop.uuid)" v-model="prop.propertyValue">-->
                </h4>
                <h4 v-if="!strIsNull(prop.propertyVocabulary?.code)">어휘번호 :
                  {{createViewVocabularyString(prop.propertyVocabulary)}}
                </h4>
                <h4 v-if="!strIsNull(prop.propertyClass?.name)">class :
                  {{prop.propertyClass?.name}}
                </h4>
                <h4 style="margin-top: 5px" v-if="prop.propertyDefine != null && prop.propertyDefine != ''"> 속성설명 :
                  <div v-b-toggle="`edit-dictionary-attr-collapse-${index}`"
                       class="tooltip_box" title="속성설명을 보려면 클릭해주세요.">
                    <span class="tooltip_ico"></span>
                  </div>
                </h4>
              </div>
              <div v-if="prop.propertyDefine != null && prop.propertyDefine != ''">
                <b-collapse :id="`edit-dictionary-attr-collapse-${index}`" class="mt-2" style="cursor:default">
                  <b-card @click.stop>
                    <p style="white-space: pre-line; text-align: left;font-size: 13px; font-weight: bold">{{ prop.propertyDefine }}</p>
<!--                    <textarea data-key="dictionaryAttribute" data-prop="propertyDefine"
                              @input="inputListener($event,prop.uuid)" @keydown="keydownListener($event,prop.uuid)" v-model="prop.propertyDefine"
                              rows="5" style="white-space: pre-line; text-align: left; font-size: 13px; font-weight: bold;">
                      {{ prop.propertyDefine }}
                    </textarea>-->
                  </b-card>
                </b-collapse>
              </div>
              <div v-if="dictionaryAttribute.filter(item => item.active).length == 0">
                <div class="nodata_txt"><p>속성POOL이 존재하지 않습니다.<br/>우측 속성추가 버튼을 이용하여 추가해주세요</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup_footer">
<!--        <a class="btn_type2" @click="revert">기본값 되돌리기</a>-->
        <a class="btn_type1" @click="saveProperty(false)">공정도속성 변경사항 저장</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import VocabularyAutocomplete from '@components/common/inputs/VocabularyAutocomplete.vue';
import {PROPERTY_TYPE, districtType, setNodeOrderByBFS} from '@/util/HubHandsonTable';
import { v4 } from "uuid";
import {createNamespacedHelpers} from 'vuex';
import Options from "@/components/nav_process/Editor/options";
const Hub = createNamespacedHelpers('Hub');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  components: {
    Options,
    Loading,
    VocabularyAutocomplete,
  },
  computed: {
    // Hub 모듈의 Getters
    ...Hub.mapGetters([
      'getEditAttributePopFlag',
      'getDictionaryPropertyList',
      'getProcessPropertyList',
      'getSelectedNode',
      'getPropertyClassList',
      'getVocabularyList'
    ]),
    // ProcessEditor 모듈의 Getters
    ...ProcessEditor.mapGetters([
        'getDiagram'
    ]),
    sortedProcessAttributes() {
      this.sortProcessAttributes();
      return this.processAttribute;
    },
    maxOrder() {
      return this.processAttribute.reduce((max, item) => {
        return item.propertyOrder > max ? item.propertyOrder : max;
      }, 0)
    },
    isDistrictValid() {
      return districtType();
    }
  },
  watch: {
    getEditAttributePopFlag: {
      // deep: true,
      // immediate: true,
      async handler(value) {
        if (value === true) {
          this.show()
        } else {
          this.visible = false;
          this.searchQuery = null;
        }
      }
    },
    getDictionaryPropertyList: {
      deep: true,
      async handler(value) {
        this.dictionaryAttribute = [];
        this.getDictionaryPropertyList.forEach(prop =>{
          const dicprop = {
            ...prop
            ,searchFlag : true //속성POOL 플래그
            ,uuid : v4() //공정도속성 키매핑용
          }
          this.dictionaryAttribute.push(dicprop);
        })
      }
    },
    getProcessPropertyList: {
      deep: true,
      async handler(value) {
        this.processAttribute = [];
        this.getProcessPropertyList.forEach(prop =>{
          const processProp = {
            ...prop
            ,uuid : this.dictionaryAttribute.find(dicprop => dicprop.dictionaryPropertyId == prop.dictionaryPropertyId).uuid
          }
          this.processAttribute.push(processProp);
        })
        this.processAttribute.sort((a,b)=> a.propertyOrder - b.propertyOrder);
      }
    },
    dictionaryAttribute: {
      deep: true,
      async handler(value) {
        //console.log('[EditAttribute.vue]dictionaryAttribute',value);
      }
    },
    processAttribute: {
      deep: true,
      async handler(value) {
        //console.log('[EditAttribute.vue]processAttribute', value);
      }
    },
    "input.forceOrderUseYn" : {
      deep: true,
      async handler(value) {
        //console.log('[EditAttribute.vue]forceOrderUseYn',value);
        if(!value){
          this.input.nodeForceOrder = null;
        }
      }
    },
    searchQuery : {
      handler (value) {
        console.log('[EditAttribute.vue]searchQuery = ',value)
        if(value == null || value == ''){
          this.dictionaryAttribute.forEach(attr => {
            attr.searchFlag = true;
          })
        }else{
          this.dictionaryAttribute.forEach(attr => {
            if(attr.propertyName.toLowerCase().includes(value.toLowerCase())){
              attr.searchFlag = true;
            }else{
              attr.searchFlag = false;
            }
          });
        }
        //console.log('[ExperimentType.vue]experimentTypeAttribute=',this.experimentTypeAttribute.filter(attr => attr.searchFlag))
      }
    }
  },
  data() {
    return {
      loading : null,
      visible : false,
      input : {
        propertyName: null,
        propertyType: null,
        propertyUnit: null,
        propertyValue: null,
        propertyDefine: null,
        propertyVocabularyId: null,
        propertyClassId: null,
        nodeForceOrder: null,
        forceOrderUseYn: null,
      },
      dictionaryAttribute : [],
      processAttribute : [],
      draggedIndex: null, // 드래그한 항목의 인덱스를 저장
      searchQuery: null, // 속성POOL 검색어
      PROPERTY_TYPE: PROPERTY_TYPE,
    }
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setEditAttributePopFlag",
          "setAttributePoolObj",
        ]
    ),
    ...Hub.mapActions(
        [
          "updateSelectedNode",
          "fetchPropertyClassList",
          "fetchVocabularyList",
        ]
    ),
    async show() {
      this.visible = true;
      this.resetData();
      await this.$nextTick();
      await this.fetchPropertyClassList();
      await this.fetchVocabularyList();
    },
    close() {
      this.setEditAttributePopFlag(false);
    },
    async refreshComponent(){
      //새로고침
      await this.updateSelectedNode({
        ...this.getSelectedNode
      });
    },
    resetData(){
      this.input = {
        propertyName: null,
        propertyType: null,
        propertyUnit: null,
        propertyValue: null,
        propertyDefine: null,
        nodeForceOrder: null,
        forceOrderUseYn: null,
      }
      this.searchQuery = null;
      if(this.getSelectedNode?.node.nodeForceOrder != null && typeof this.getSelectedNode?.node.nodeForceOrder === 'number'){
        this.input.forceOrderUseYn = true
        this.input.nodeForceOrder = this.getSelectedNode?.node.nodeForceOrder;
      }else{
        this.input.forceOrderUseYn = false
      }
    },
    async revert(){
      if(await window.confirm("모든 변경사항을 초기화하고 저장 전 상태로 되돌리시겠습니까?")){
       this.resetData();
       await this.refreshComponent();
      }
    },
    inputListener(v,id) {
      const target = v.target.getAttribute('data-key');
      const targetProp = v.target.getAttribute('data-prop');
      switch (target){
        case "input":
          this[target][id] = v.target.value;
          break;
        case "searchQuery":
          this[target] = v.target.value;
          break;
        default :
          if(targetProp != null && targetProp != ''){
            this[target].find(obj=> obj.uuid == id)[targetProp] = v.target.value;
          }
          break;
      }
    },
    keydownListener(v,id) {
      const target = v.target.getAttribute('data-key');
      const targetProp = v.target.getAttribute('data-prop');
      switch (target){
        case "input":
          this[target][id] = v.target.value;
          break;
        case "searchQuery":
          this[target] = v.target.value;
          break;
        default :
          if(targetProp != null && targetProp != ''){
            this[target].find(obj=> obj.uuid == id)[targetProp] = v.target.value;
          }
          break;
      }
    },
    async saveProperty(closeFlag){
      const flag = await window.confirm("변경사항을 저장하시겠습니까?");
      if(!flag) return;
      try {
        this.loading = true;
        //0.노드강제순서 저장
        //중복되는 강제순서가 있는 확인
        const allNodeData = this.getDiagram.model.nodeDataArray;
        const duplicateForceOrderNode = allNodeData.filter(node => {
          return (node.nodeForceOrder == parseInt(this.input.nodeForceOrder)) && node.key != this.getSelectedNode.key
        });
        if(this.input.forceOrderUseYn){
          if(!(this.input.nodeForceOrder > 0 && this.input.nodeForceOrder % 1 === 0)){
            alert("강제지정 순서는 양의정수만 가능합니다.")
            return;
          }
        }
        if(this.input.forceOrderUseYn && duplicateForceOrderNode.length > 0) {
          let category = "";
          switch (duplicateForceOrderNode[0].category){
            case "EQUIPMENT":
              category = "측정/분석";
              break
            case "MATERIAL":
              category = "재료";
              break
            case "PROCESS":
              category = "공정";
              break
          }
          window.alert(`강제지정 순서가 중복됩니다. \n중복노드명 : [${category}]${duplicateForceOrderNode[0].text}`);
          return;
        }

        // 이미 다이어그램에 그려진 노드에 key 속성 추가
        const nodeData = this.getDiagram.model.findNodeDataForKey(this.getSelectedNode.key); // 해당 노드의 데이터를 찾음
        if (nodeData && this.input.forceOrderUseYn) {
          this.getDiagram.model.setDataProperty(nodeData, "nodeForceOrder",parseInt(this.input.nodeForceOrder));  // 해당 노드에 "nodeForceOrder" 속성 추가
        }else if(nodeData && !this.input.forceOrderUseYn){
          this.getDiagram.model.setDataProperty(nodeData, "nodeForceOrder", null);
        }
        //노드 순서 적용
        setNodeOrderByBFS(this.getDiagram.model.nodeDataArray, this.getDiagram.model.linkDataArray,this.getDiagram.model);
        //1.사전속성 저장
        // => 생성시 저장으로 변경
        /*const dictionaryPropList = await this.$wApi.property.updateDictionaryProperty(this.dictionaryAttribute);*/
        //console.log(`[EditAttribute.vue]updateDictionaryProperty`, dictionaryPropList)
        //2.공정도속성 uuid 매핑 후 사전속성id 세팅
        this.processAttribute.forEach(processProp => {
          const parentDictionaryProp = this.dictionaryAttribute.find(dicProp => dicProp.uuid == processProp.uuid);
          if(parentDictionaryProp.dictionaryPropertyId == null) throw new Error(`사전속성 아이디 매핑 실패 ${this.parentDictionaryProp}`);
          processProp.dictionaryPropertyId = parentDictionaryProp.dictionaryPropertyId;
        })
        //3.공정도속성 저장
        const res = await this.$wApi.property.updateProcessProperty(this.processAttribute);
        //console.log(`[EditAttribute.vue]updateDictionaryProperty`, res)
        if(!res.error){
          alert("저장됐습니다.");
        }else{
          alert(`에러발생 ${res.message}`);
        }

        if(!closeFlag){
          //새로고침
          this.resetData();
          await this.refreshComponent();
        }else{
          this.setEditAttributePopFlag(false);
        }
      }catch (e) {
          window.alert(e);
      }finally {
          this.loading = false;
      }

    },
    async addDictionaryProperty(){
      for(let key in this.input){
        if(!['nodeForceOrder','forceOrderUseYn','propertyVocabularyId','propertyClassId'].includes(key) && (this.input[key] == null || this.input[key].trim() == '')){
          let validFlag = true;
          let validMsg = '';
          switch (key){
            case "propertyName":
              validMsg ='속성명을 입력해주세요.';
              break
            case "propertyType":
              validMsg ='속성타입을 선택해주세요.';
              break
            case "propertyUnit":
            case "propertyValue":
            case "propertyDefine":
              validFlag = false;
              break
          }
          if(validFlag){
            alert(validMsg);
            return;
          }
        }
      }

      const uuid = v4();

      if(this.dictionaryAttribute.filter(item => {
        return item.active && item.propertyName == this.input.propertyName
            && item.propertyUnit == this.input.propertyUnit && item.propertyType == this.input.propertyType
      }).length > 0){
        alert('이미 추가된 속성이 있습니다.')
        return;
      }
      let newDictionaryAttribute = {
        dictionaryPropertyId : null
        ,dictionaryId : this.getSelectedNode.dictionaryId
        ,userId : this.user.id
        ,propertyName : this.input.propertyName
        ,propertyType : this.input.propertyType
        ,propertyUnit : this.isDistrictValid.includes(this.input.propertyType)? "" : this.input.propertyUnit
        ,propertyOrder : 0 //TODO 추후 통계 데이터 활용하여 order by
        ,propertyDefine : this.input.propertyDefine
        ,propertyValue : this.isDistrictValid.includes(this.input.propertyType)? "" : this.input.propertyValue
        ,propertyClassId : this.input.propertyClassId
        ,propertyClass : this.getPropertyClassList.find(c=>c?.id==this.input.propertyClassId)
        ,propertyVocabularyId : this.input.propertyVocabularyId
        ,propertyVocabulary : this.getVocabularyList.find(c=>c?.id==this.input.propertyVocabularyId)
        ,active : true
        ,uuid : uuid //공정도속성 키매핑용
        ,searchFlag : true //검색용 플래그
      };
      //console.log(newDictionaryAttribute)
      this.searchQuery = null;
      try {
        const dictionaryProp = await this.$wApi.property.updateDictionaryProperty([newDictionaryAttribute]);

        if (!dictionaryProp.error) {
          dictionaryProp.forEach(prop => {
            this.dictionaryAttribute.push({...newDictionaryAttribute, dictionaryPropertyId: prop.dictionaryPropertyId})
          });

          //박사님 요청으로 인한 공정도 적용속성 바로 적용
          await this.addProcessAttribute(null, uuid);
        } else {
          alert(`${res.message}`);
          return;
        }
      }catch (e){
        console.log(e);
        alert("에러! 관리자에게 문의해주세요.");
      }
    },
    async addProcessAttribute(dictionaryPropertyId, uuid){
      const duplicateProcessProperty = this.processAttribute.find(item => item.uuid == uuid);
      if(duplicateProcessProperty != null && duplicateProcessProperty.active){
        alert('이미 추가된 속성입니다.')
        return;
      }

      const selectedDictionaryAttribute = this.dictionaryAttribute.find(item => item.uuid == uuid);
      //기존에 지웠던 공정도 속성이 있는 경우 복구
      if(duplicateProcessProperty != null && !duplicateProcessProperty.active){
        duplicateProcessProperty.active = true;
        // 추가된 컬럼도 최신화 되도록 세팅
        duplicateProcessProperty.propertyClass = selectedDictionaryAttribute.propertyClass;
        duplicateProcessProperty.propertyClassId = selectedDictionaryAttribute.propertyClassId;
        duplicateProcessProperty.propertyVocabulary = selectedDictionaryAttribute.propertyVocabulary;
        duplicateProcessProperty.propertyVocabularyId = selectedDictionaryAttribute.propertyVocabularyId;
        this.sortProcessAttributes();
      }else{
        //신규공정도 속성인 경우
        this.processAttribute.push({
          processPropertyId : null
          ,processId : this.getSelectedNode.processId
          ,dictionaryKeyLinkId : this.getSelectedNode.dictionaryKeyLinkId
          ,dictionaryId : this.getSelectedNode.dictionaryId
          ,dictionaryPropertyId : selectedDictionaryAttribute.dictionaryPropertyId != null ? selectedDictionaryAttribute.dictionaryPropertyId : null
          ,userId : this.user.id
          ,propertyName : selectedDictionaryAttribute.propertyName
          ,propertyType : selectedDictionaryAttribute.propertyType
          ,propertyUnit : selectedDictionaryAttribute.propertyUnit
          ,propertyOrder : this.maxOrder+1
          ,propertyDefine : selectedDictionaryAttribute.propertyDefine
          ,propertyValue : selectedDictionaryAttribute.propertyValue
          ,propertyVocabulary : selectedDictionaryAttribute.propertyVocabulary
          ,propertyVocabularyId : selectedDictionaryAttribute.propertyVocabularyId
          ,propertyClass : selectedDictionaryAttribute.propertyClass
          ,propertyClassId : selectedDictionaryAttribute.propertyClassId
          ,active : true
          ,uuid : selectedDictionaryAttribute.uuid
          ,experimentId : this.getSelectedNode.experimentId
        })
        this.sortProcessAttributes();
      }
    },
    async deleteAttribute(target,uuid){
      const index = this[target].findIndex(obj => obj.uuid == uuid);
      if (index === -1) return;

      if (target === "dictionaryAttribute") {
        const flag = await window.confirm('속성POOL 삭제 시 되돌릴 수 없습니다.\n정말 삭제하시겠습니까?')
        if(!flag) return;
        const processAttributeIndex = this["processAttribute"].findIndex(obj => obj.uuid == uuid && obj.active);
        //사전속성 삭제 검증
        if(this[target][index].dictionaryPropertyId != null && this[target][index].dictionaryPropertyId > 0){
          //DB에 있는경우만
          try {
            const res = await this.$wApi.property.getDeleteValidationProperty({
               dictionaryPropertyId : this[target][index].dictionaryPropertyId,
               dictionaryKeyLinkId : this.getSelectedNode.dictionaryKeyLinkId
            });

            if(res.error){
              alert(`${res.message}`);
              return;
            }

            if (processAttributeIndex !== -1) {
              if (await window.confirm('해당 속성POOL 속성을 참조한 공정도속성이 존재합니다. \n정말 삭제하시겠습니까?')) {
                this.loading = true;
                //공정도속성
                const processTarget = await this.deleteItem("processAttribute",this["processAttribute"], processAttributeIndex);
                await this.$wApi.property.updateDictionaryProperty([processTarget]);
                //사전속성
                await this.deleteItem(target,this[target], index);
              }
            }else{
              this.loading = true;
              await this.deleteItem(target,this[target], index);
            }

          }catch (e){
            console.log(e);
            alert("에러! 관리자에게 문의해주세요.");
          }finally {
            this.loading = false;
          }
        }
      } else {
        const flag = await window.confirm('정말 삭제하시겠습니까?')
        if(!flag) return;
        await this.deleteItem(target,this[target], index);
      }
    },
    // 삭제 로직
    async deleteItem(target,list,idx){
      if (idx !== -1) {
        //console.log('list[idx]',list[idx]);
        if(target==='processAttribute'){
          //공정도속성
          if(list[idx].processPropertyId != null && list[idx].processPropertyId >0){
            //DB에 있는경우 => active false 처리
            list[idx].active = false;
            return list[idx];
          }else{
            //DB에 없는경우 => list에서 제거
            list.splice(idx, 1);
          }
        }else if(target==='dictionaryAttribute'){
          //사전속성
          if(list[idx].dictionaryPropertyId != null && list[idx].dictionaryPropertyId >0){
              //DB에 있는경우 => active false 처리
              list[idx].active = false;
              this.sortProcessAttributes();
              await this.$wApi.property.updateDictionaryProperty([list[idx]]);
          }else{
            //DB에 없는경우 => list에서 제거
            list.splice(idx, 1);
          }
        }
      }
    },
    sortProcessAttributes() {
        // propertyOrder를 순서대로 재설정
        let order = 1;
        this.processAttribute.forEach(item => {
          if (item.active) {
            item.propertyOrder = order++;
          }
        });
        // active가 false인 항목에는 뒤쪽부터 순서를 부여
        this.processAttribute.forEach(item => {
          if (!item.active) {
            item.propertyOrder = order++;
          }
        });
        this.processAttribute.sort((a,b) => a.propertyOrder - b.propertyOrder);
    },
    attrDragStart(event, index) {
      this.draggedIndex = index; // 드래그된 항목의 인덱스를 저장
      event.dataTransfer.effectAllowed = 'move';
    },

    attrDragDrop(event,dropIndex) {
     if (this.draggedIndex !== null && this.draggedIndex !== dropIndex) {
        // 드래그된 항목
        const draggedItem = this.processAttribute[this.draggedIndex];
        // 드래그된 항목을 배열에서 삭제하고 새로운 위치에 추가
        this.processAttribute.splice(this.draggedIndex, 1); // 드래그된 항목 제거
        this.processAttribute.splice(dropIndex, 0, draggedItem); // 새로운 위치에 추가

        this.sortProcessAttributes();
      }
      // 드래그 인덱스 초기화
      this.draggedIndex = null;
    },
    setBackgroundColor(category){
      switch (category){
        case "MATERIAL":
          return {backgroundColor:"#684D92"};
        case "PROCESS":
          return {backgroundColor:"#0F64CE"};
        case "EQUIPMENT":
          return {backgroundColor:"#5D9C3D"};
      }
    },
    setExistColor(prop){
      if(this.processAttribute.filter(item => item.uuid == prop.uuid && item.active).length > 0){
        return {backgroundColor:"#f1f1f1"};
      }
    },
    callEditAttributePollPop(dictionaryProp){
      this.setAttributePoolObj({
        openFlag: true,
        dataObj: {...dictionaryProp}
      });
    },
    strIsNull(string){
      return string == null || string == ""
    },
    handleVocabularySelect(selectedItem) {
      if(selectedItem != null) {
        this.input.propertyVocabularyId = String(selectedItem.id);
      }else{
        this.input.propertyVocabularyId = null;
      }
    },
    createViewVocabularyString(propertyVocabulary){
      let result = "";
      if(propertyVocabulary == null){
        return result;
      }
      result += propertyVocabulary.code + "(";
      if(propertyVocabulary.system1 != null && propertyVocabulary.system1){
        result += propertyVocabulary.system1;  
      }
      if(propertyVocabulary.system2 != null && propertyVocabulary.system2){
        result += " / " + propertyVocabulary.system2;   
      }
      result += ")";
      return result;
    }
  }
}
</script>

<style lang="scss">
@import "@/style/new/css/cyl.common.css";
.editAttribute  {display:block;position:fixed; width:1300px;height:90%;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
@media screen and (max-width: 1250px) {
  .editAttribute {width:95%;}
}
</style>